import "./AchievementDialogComponent.scss";
import template from "./AchievementDialogComponent.html";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {AchievementService} from "../service/AchievementService";
import {BehaviorSubject, Observable, ReplaySubject} from "rxjs";
import {AchievementState, AchievementStates, sortStates} from "../models/AchievementState";
import {achievementTemplate} from "../popup/AchievementTemplate";
import {sum} from "../../../js/util/UtilFunctions";

export const AchievementDialog = "tfAchievementDialog";

export function achievementDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<"
        },
        controllerAs: "ctrl",
        controller: AchievementDialogComponentController
    };
}

export class AchievementDialogComponentController implements IOnInit {

    /** @input */
    public readonly modalInstance: IModalInstanceService;

    public readonly unlockedCount$ = new ReplaySubject<number>(1);
    public readonly totalCount$ = new ReplaySubject<number>(1);
    public readonly totalPoints$ = new ReplaySubject<number>(1);
    public readonly achievements$ = new ReplaySubject<ReadonlyArray<string>>(1);

    public readonly hasError$ = new BehaviorSubject(false);

    /** @ngInject */
    public constructor(private readonly achievementService: AchievementService) {

    }

    public $onInit(): void {
        const list = this.achievementService.list();
        const source$ = Observable.fromPromise(list);
        source$.map((achievements) => this.sortAchievements(achievements))
               .map((achievements) => this.createTemplates(achievements))
               .subscribe((achievements) => this.achievements$.next(achievements),
                          (err) => this.hasError$.next(true));
        source$.map((achievements) => this.countUnlocked(achievements))
               .subscribe((unlocked) => this.unlockedCount$.next(unlocked));
        source$.map((achievements) => achievements.length)
               .subscribe((count) => this.totalCount$.next(count));
        source$.map((achievements) => this.totalPoints(achievements))
               .subscribe((points) => this.totalPoints$.next(points));
    }

    private sortAchievements(achievements: AchievementStates): AchievementStates {
        return [...achievements].sort(sortStates());
    }

    private createTemplates(achievements: AchievementStates): ReadonlyArray<string> {
        return achievements.map((a) => this.createTemplate(a));
    }

    private createTemplate(achievement: AchievementState): string {
        const baseTemplate = achievementTemplate(achievement.name, achievement.value);
        const achievementClass = achievement.unlocked ? "" : "locked";
        return `
            <div class="${achievementClass}">
                ${baseTemplate}            
            </div>
        `;
    }

    public close() {
        this.modalInstance.close();
    }

    private countUnlocked(achievements: ReadonlyArray<AchievementState>): number {
        return achievements.filter((a) => a.unlocked).length;
    }

    private totalPoints(achievements: ReadonlyArray<AchievementState>): number {
        return achievements.filter((a) => a.unlocked)
                           .map((a) => a.value)
                           .reduce(sum, 0);
    }
}
